import React from "react";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import { Navigate } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import { CACHE_KEYS } from "@rentablo/api/apiv1";

export interface Props {
  investmentName: string;
  redirectUrl: string;
}

export const PersistedStep = ({ investmentName, redirectUrl }: Props) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  enqueueSnackbar(
    `${t("transactionWizard.persistedStep.title")}: ${investmentName}`,
    { autoHideDuration: 3000, variant: "success" }
  );
  queryClient.invalidateQueries({
    queryKey: [CACHE_KEYS.LIST_AND_SEARCH_ALL_ACCOUNTS],
  });

  queryClient.invalidateQueries({
    queryKey: [CACHE_KEYS.LIST_AND_SEARCH_ALL_INVESTMENTS],
  });

  return <Navigate replace to={redirectUrl} />;
};
